import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
  imports: [MatPrefix, MatSuffix, MatIconButton, FormsModule, MatFormField, MatInput, NgClass],
  selector: 'app-search-input',
  standalone: true,
  templateUrl: './search-input.component.html',
})
export class SearchInputComponent {
  @Input() placeholder = 'Enter Search text';
  @Input() inputValue = '';
  @Input() inputWidth = '256px';
  @Input() cssClass = '';
  @Input() clearOnBlur = false;
  @Output() searchDataEvent = new EventEmitter<string>();

  clear() {
    this.inputValue = '';
    this.searchDataEvent.emit('');
  }

  protected modelChange(value: string) {
    this.searchDataEvent.emit(value.trim());
  }

  protected blurEvent() {
    if (!this.clearOnBlur) {
      return;
    }
    setTimeout(() => {
      this.clear();
    }, 500);
  }
}
